export const translations = {
  'nl-NL': {
    translation: {
      addUser: 'Gebruiker toevoegen',
      editUser: 'Gebruiker bewerken',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      name: 'Naam',
      role: 'Rol',
      status: 'Status',
      email: 'E-mail',
      phone: 'Telefoon',
      type: 'Type',
      details: 'Details',
      nodes: 'Knooppunten',
      roles: 'Rollen',
      cancel: 'Annuleren',
      submit: 'Verzenden',
      delete: 'Verwijderen',
      create: 'Maken',
      deleteNodeError: 'Fout bij het verwijderen van knooppunt',
      deleteConfirmation: 'Weet u zeker dat u wilt verwijderen?',
      warning: 'Waarschuwing',
      Alert: 'Waarschuwing',
      deleteSure: 'Ja, ik weet het zeker',
      nodesWillBeCreatedAt: 'Knooppunten worden aangemaakt op',
      searchFor: 'Zoeken naar',
      rolesError: 'Fout bij het ophalen van rollen',
      userListError: 'Fout bij het ophalen van de gebruikerslijst',
      organisationListError: 'Fout bij het ophalen van de organisatielijst',
      loadingRoles: 'Rollen worden geladen',
      selectRole: 'Selecteer rol',
      validEmail: 'Voer een geldig e-mailadres in',
      requiredEmail: 'E-mail is vereist',
      resend: 'Opnieuw verzenden',
      restrictedDomain: 'Beperkt e-maildomein',
      addUserSuccess: 'Gebruiker succesvol toegevoegd',
      editUserSuccess: 'Gebruiker succesvol bewerkt',
      deleteUserSuccess: 'Gebruiker succesvol verwijderd',
      deleteModalAlertMessage:
        'U staat op het punt de gebruiker {{userName}} te verwijderen. Alle rechten voor de gebruiker worden ingetrokken.',
      deleteProceedMessage: 'Wilt u doorgaan met het verwijderen?',
      userAlreadyExist: 'Gebruiker met dit e-mailadres bestaat al.',
      addUserError: 'Kon gebruiker niet toevoegen. Probeer het opnieuw.',
      editUserError: 'Kon gebruiker niet bewerken. Probeer het opnieuw.',
      deleteUserError: 'Kon gebruiker niet verwijderen. Probeer het opnieuw.',
      nodesError: 'Fout bij het ophalen van toegewezen knooppunten',
      childNodesError: 'Fout bij het laden van hiërarchieniveau',
      hierarchyError: 'Fout bij het ophalen van hiërarchie',
      requestFailed: 'Verzoek mislukt',
      emailSentSuccess: 'Activeringsmail succesvol verzonden!',
      activationEmailError: 'Activeringsmail verzenden mislukt.',
      activationEmailError1:
        'Het is niet gelukt om de activeringsmail te versturen. Probeer het later opnieuw.',
      allOrganisations: 'Alle organisaties',
      address: 'Adres',
      hierarchyMetaError: 'Fout bij het ophalen van hiërarchiedetails',
      nodeMetaError: 'Fout bij het laden van knooppuntdetails',
      contactName: 'Naam contactpersoon',
      downloadTemplate: 'Sjabloon downloaden',
      newOrg: 'Nieuwe organisatie',
      save: 'opslaan',
      upload: 'uploaden',
      uploading: 'Bezig met uploaden',
      dropExcel: 'Excel-blad neerzetten, of',
      browse: 'bladeren',
      importSettings: 'Instellingen importeren',
      addNodesSites: 'Nieuwe knooppunten/sites toevoegen',
      updateNodesSites: 'Werk informatie over bestaande knooppunten/sites bij',
      disableNodesSites: 'Schakel knooppunten/sites uit die niet meer bestaan',
      disabled: 'Uitgeschakeld',
      new: 'Nieuw',
      updated: 'Bijgewerkt',
      siteInstallation: 'Sites',
      addOrgSuccess: 'Organisatie met succes gemaakt.',
      excelUploadError: 'Excel opslaan mislukt. Probeer het opnieuw.',
      saveError: 'Opslaan mislukt. Probeer het opnieuw.',
      saveBadRequestError:
        'Opslaan mislukt. Dit heeft waarschijnlijk te maken met de gegevens die u probeerde op te slaan.',
      telephone: 'Telefoon',
      externalIds: "Externe ID's",
      contactEmail: 'Contact-e-mailadres',
      longitude: 'Lengtegraad',
      latitude: 'Breedtegraad',
      primaryContactName: 'Naam primaire contactpersoon',
      primaryContactEmail: 'Primair contact e-mailadres',
      templateError:
        'Fout bij het downloaden van sjabloon. Probeer het later opnieuw.',
      templateError1: 'Sjabloon ophalen mislukt. Probeer het later opnieuw.',
      home: 'Startpagina',
      organisations: 'Organisaties',
      users: 'Gebruikers',
      lightTheme: 'Licht thema',
      darkTheme: 'Donker thema',
      login: 'Aanmelden',
      logout: 'Uitloggen',
      activateUserAcc: 'Gebruikersaccount activeren',
      phoneNumber: 'Telefoonnummer',
      optional: 'facultatief',
      password: 'Wachtwoord',
      confirmPassword: 'Bevestig wachtwoord',
      endUser: 'Licentieovereenkomst voor eindgebruikers',
      iAccept: 'Ik ga akkoord met de licentieovereenkomst voor eindgebruikers.',
      iHereby: 'Hierbij bevestig ik het lezen en accepteren van de',
      eula: 'Gebruiksrechtovereenkomst',
      iRead: 'Ik heb het privacybeleid van Honeywell gelezen',
      iUnderstood: 'Ja, ik heb de verklaring gelezen en ga ermee akkoord',
      privacyPolicy: 'Privacybeleid',
      activate: 'activeren',
      activationSuccess: 'Activering succesvol',
      newAccAccess:
        'Om toegang te krijgen tot uw nieuwe account, logt u in met uw nieuwe gebruikersnaam. Deze nieuwe gebruikersnaam wordt hieronder weergegeven:',
      emailSent:
        'Er is een nieuwe gebruikersnaam naar uw e-mailadres verzonden.',
      signin: 'AANMELDEN',
      activationError: 'Activering mislukt',
      pleaseTryAgain: 'Probeer het opnieuw',
      activationExpired: 'Activeringstoken verlopen',
      activationExpiredText:
        'Dit kan zijn omdat er een time-out is opgetreden in de e-maillink, deze al is gebruikt of onjuist was. Als het probleem zich blijft voordoen, vraag dan een nieuwe activeringsmail aan.',
      contactSupport: 'Fout. Neem contact op met de ondersteuning',
      pwdMatch: 'Wachtwoorden moeten overeenkomen',
      required: 'Vereist',
      eligiblePwd:
        'Wachtwoord moet ten minste 1 hoofdletter, 1 kleine letter, 1 cijfer, 1 speciaal teken en ten minste 11 tekens bevatten',
      invalidPhoneNumber: 'Telefoonnummer ongeldig',
      invalidName:
        'Naam mag niet langer zijn dan 255 tekens zonder voor- of achterspaties',
      invalidFirstName: 'Voornaam bevat ongeldige tekens.',
      invalidLastName: 'Achternaam bevat ongeldige tekens.',
      timezone: 'tijdzone',
      timeZone: 'Tijdzone',
      commissioningStatus: 'Status van inbedrijfstelling',
      countryCode: 'Landcode',
      childCount: 'Aantal onderliggende elementen',
      sheetVersion: 'Bladversie',
      unknownError: 'Onbekende fout. Probeer het later opnieuw.',
      preview: 'Voorbeeld',
      file: 'Bestand',
      inCompatibleExcel: 'Bestand moet in de .xlsx-indeling zijn.',
      selectOrg: 'Selecteer organisatie',
      noRecordFound: 'Geen registraties gevonden',
      total: 'Totaal',
      items: 'Artikelen',
      forbidden: 'Verboden',
      noPermissionText: 'U heeft geen toestemming om deze pagina te openen',
      accessPermission: 'Meld u aan bij een account met toegangsrechten',
      technicianExternalAccessPermission:
        'Log alstublieft in op de mobiele applicatie.',
      redirectToLogin: 'Doorverwijzen naar inlogpagina',
      errorUserSettings: 'Fout bij het ophalen van gebruikersinstellingen',
      invalidSystemGuid: 'Ongeldige Systeem-GUID',
      languageNotSupported: 'Taal wordt niet ondersteund',
      subscriptions: 'Abonnementen',
      gatewayManagement: 'Gateway-beheer',
      subscriptionNumber: 'Abonnementsnummer',
      orderNumber: 'Bestelnummer',
      bundle: 'Bundel',
      activatedOn: 'activeringsdatum',
      order: 'volgorde',
      editSubscription: 'Abonnement bewerken',
      noNodeSelected: 'Geen knooppunt geselecteerd',
      noUserSelected: 'Geen gebruiker geselecteerd',
      loadingBundles: 'Bundels worden geladen',
      bundlesError: 'Fout bij het ophalen van bundels',
      selectBundle: 'Selecteer bundel',
      addSubscriptionSuccess: 'Abonnement succesvol toegevoegd',
      addSubscriptionError:
        'Kan geen abonnement toevoegen. Probeer het opnieuw.',
      subscriptionInputValidationError:
        'kan een alfanumerieke waarde met een koppelteken zijn en mag niet langer zijn dan 13 tekens',
      errorUserGlobalPrivileges:
        'Fout bij het ophalen van globale gebruikersprivileges',
      subscriptionAlreadyExist: 'Abonnement bestaat al.',
      invalidSubscription: 'Ongeldig abonnement',
      Version: 'Versie',
      systemType: 'Soort systeem',
      systemId: 'Systeem-ID',
      reviewGatewayDetails: 'Gateway-details bekijken',
      site: 'Site',
      Organisation: 'Organisatie',
      gatewayRegistration: 'Gateway-registratie',
      selectAnOrg: 'Selecteer een organisatie',
      selectASite: 'Selecteer een site',
      register: 'Registreren',
      selectSiteToRegsiter: 'Selecteer site om de gateway te registreren',
      gatewayRegistrationFailureMsg:
        'Kan de gateway niet registreren bij het Honeywell Sentience IOT-platform',
      gatewayRegistrationSuccessMsg:
        'Gateway is met succes geregistreerd bij het Honeywell Sentience IOT Platform',
      siteEmptyMsg:
        'Alle sites voor de organisatie {{- orgName}} zijn al geregistreerd',
      forgeOnboarding: 'Organisatiekoppeling',
      SiteFetchingFailure: 'Kan geen sites ophalen uit Forge',
      selectAllSitesText:
        'Selecteer alle Forge-sites om in de Remote Building Manager te introduceren',
      onBoardingFailure: 'Kan de onboarding van de site niet starten',
      customerID: 'Klant-ID',
      enterCustomerID: 'Voer klant-ID in',
      loadingSites: 'Sites worden geladen',
      fetchSites: 'SITES OPHALEN',
      subscriptionActivateSuccess:
        'Abonnement voor "{{siteName}}" is succesvol geactiveerd',
      subscriptionActivateError:
        'Activeren vanwege technisch probleem niet mogelijk, neem contact met uw beheerder op',
      activateNow: 'Nu activeren',
      multiSiteSuccess: 'Sites zijn succesvol toegevoegd.',
      onboardSelected: 'Geselecteerde introduceren',
      sitePartialSuccess:
        'Door een technisch probleem konden sommige sites niet worden geïntroduceerd. Probeer het opnieuw of neem contact met uw beheerder op.',
      confirm: 'Bevestigen',
      onboardingFailed: 'Onboarding mislukt',
      failed: 'mislukt',
      onboardedSuccessfully: 'Site geïntroduceerd',
      notOnboarded: 'Niet geïntroduceerd',
      onboarding: 'Aan boord...',
      reOnboard: 'Opnieuw introduceren',
      selectAll: 'Alles selecteren',
      siteSuccess: 'Site succesvol toegevoegd.',
      dataloseWarning:
        'Vernieuw de pagina niet terwijl sites worden geïntroduceerd.',
      addServiceSuccess: 'Diensten succesvol toegevoegd',
      addServicesText: 'Diensten toevoegen',
      validityText: 'Geldigheidsduur',
      invalidInputError: 'Ongeldige invoer',
      subsactivateError: 'Abonnement al geactiveerd',
      subsnotfoundError: 'Abonnementsgegevens niet gevonden',
      invalidorderError: 'Ongeldig bestelnummer',
      bundnotfoundError: 'Bundeldetails niet gevonden',
      subscribedServices: 'GEABONNEERDE DIENSTEN',
      subsactivateSuccess: 'Abonnement met succes gemaakt en geactiveerd',
      subsactivateFailure:
        'Abonnement gemaakt, maar activering mislukt. Probeer het opnieuw.',
      subsactivateDiffSite: 'Abonnement al geactiveerd voor een andere site',
      gatewayAssociation: 'Gatewaykoppeling',
      systemGuid: 'Systeem-GUID',
      success: 'Gelukt',
      contactSystemAdministrator: 'Neem contact op met uw systeembeheerder',
      siteName: 'Sitenaam',
      location: 'Locatie',
      action: 'Actie',
      addNewSite: 'Nieuwe site toevoegen',
      add: 'Toevoegen',
      sitesAssociated: '{{siteCount}} sites gekoppeld',
      numberOfAddon: 'Nummer van add-on',
      searchSite: 'Sites zoeken',
      noResultFound: 'Geen resultaten gevonden',
      noDataFound: 'Geen gegevens gevonden',
      loadMore: 'Meer laden',
      unlinkMessage:
        'Om {{siteName}} los te koppelen van de {{sku}}, neem dan contact op met Honeywell Customer Care center (+01 480-353-3020) of e-mail support@honeywell.com',
      associatedOrderNumber: 'Bijbehorend bestelnummer',
      associatedSubscriptionNumber: 'Bijbehorend abonnementsnummer',
      helperTextSKU:
        'Om het abonnementsnummer te wijzigen, neem dan contact op',
      helperOrderTextSKU:
        'Neem contact met [entity] op om het bestelnummer te wijzigen',
      customerCare: 'Klantenservice',
      skuDetails: 'Details van SKU',
      manageSites: 'Sites beheren',
      skuName: 'SKU-naam',
      skuDescription: 'SKU Beschrijving',
      licenseUtilization: 'Licentiegebruik',
      validTill: 'Geldig tot',
      editSKU: 'SKU bewerken',
      duplicateSiteError: 'Site is al toegevoegd',
      numberOfAddonRequired: 'Voer het nummer van de add-on in',
      siteFetchError: 'Fout bij het ophalen van de sitelijst',
      siteSuccessMsg: 'Sites succesvol toegevoegd',
      siteFailedMsg: 'Sites toevoegen mislukt',
      problemWithRequest: 'Er was een probleem met de aanvraag.',
      newSubscriptionAdded: 'Nieuw abonnement toegevoegd',
      licensesOf: 'Licenties van',
      all: 'Alle',
      orderPlacedBy: 'Bestelling geplaatst door',
      pendingRenewal: 'In afwachting van verlenging',
      daysRemaining: 'Resterende dagen',
      renewSubscriptionMessage:
        'Neem voor het verlengen van {{skuName}} contact op met Honeywell Customer Care center (+01 480-353-3020) of e-mail support@honeywell.com',
      columnSelection: 'Kolomselectie',
      selectUpTo: 'Maximale selectie: ',
      itemsToDisplay: 'items die in de tabel moeten worden weergegeven.',
      subscriptionManagement: 'Abonnementsbeheer',
      activated: 'Geactiveerd',
      warningHeader: 'Weet je zeker dat je wilt annuleren?',
      warningMessage:
        'Er zijn niet-opgeslagen wijzigingen die verloren kunnen gaan',
      renewSubscription: 'Abonnement verlengen',
      pendingActivation: 'In afwachting van activering',
      notAuthorizedError:
        'U bent niet gemachtigd om de SKU aan deze organisatie toe te wijzen.',
      gatewayRegistrationInProgress: '{{gateway}} in uitvoering',
      gatewayAssociationFailed:
        'Controleer de gateway-connectiviteit en probeer het opnieuw. Als dit opnieuw niet lukt, neem dan contact op met uw systeembeheerder.',
      gatewayRegistrationFailed:
        'Probeer het opnieuw. Neem contact met uw systeembeheerder op als het opnieuw mislukt.',
      doAssociationMessage:
        'Controleer de gateway-connectiviteit en ga verder met de gateway-koppeling.',
      errorInAssociation: 'Fout bij het verwerken van de associatie.',
      association: 'Koppeling',
      dataloseWarningForRegistration:
        'Poort wordt geregistreerd. Dit kan een paar minuten duren. Om gegevensverlies te voorkomen, mag u de pagina niet vernieuwen.',
      dataloseWarningForAssociation:
        'Poort wordt gekoppeld. Dit kan een paar minuten duren. Om gegevensverlies te voorkomen, mag u de pagina niet vernieuwen.',
      objectName: 'Naam object',
      objectType: 'Soort object',
      unitName: 'Eenheid',
      bitunpack: 'Bit uitpakken',
      bitRange: 'Bitbereik',
      propName: 'Naam eigenschap',
      propDataType: 'Gegevenstype',
      propValue: 'Waarde eigenschap',
      msgType: 'SOORT BERICHT',
      isMultiState: 'Is Multi-status',
      scalingOperation: 'Schaalbewerking',
      scalingFactor: 'Schaalfactor',
      byteOrder: 'Bytevolgorde',
      propertyName: 'Naam eigenschap',
      addTemplateSuccess: 'Sjabloon succesvol toegevoegd',
      addTemplateError: 'Kan geen sjabloon toevoegen. Probeer het opnieuw.',
      updateTemplateSuccess: 'Sjabloon succesvol bijgewerkt',
      updateTemplateError: 'Kon sjabloon niet bijwerken. Probeer het opnieuw.',
      outOfRangeError: 'Waarde moet tussen {{min}} en {{max}} liggen',
      requiredField: 'Vul alle velden in',
      templateName: 'Sjabloonnaam',
      modelName: 'Modelnaam',
      vendorName: 'Leveranciersnaam',
      uniqueValueError: 'Waarde moet uniek zijn',
      templateMangement: 'Sjabloonbeheer',
      equipmentType: 'Soort apparatuur',
      selectType: 'Selecteer Type',
      listOfTemplate: 'Lijst van sjablonen',
      selectTemplate: 'Sjabloon selecteren',
      ElectricityVoltage: 'Elektriciteitsspanning',
      ElectricityCurrent: 'Elektriciteitsstroom',
      ElectricPowerFactor: 'Elektrische arbeidsfactor',
      ElectricFrequency: 'Elektrische frequentie',
      EnergyReceived: 'Energie ontvangen',
      ActivePower: 'Actief vermogen',
      ActivePowerA: 'Actief vermogen A',
      ActivePowerB: 'Actief vermogen B',
      ActivePowerC: 'Actief vermogen C',
      ReactivePower: 'reactief vermogen',
      ApparentPower: 'Aanwezige voeding',
      PeakDemand: 'Piekvraag',
      ElectricityCurrentA: 'Elektriciteitsstroom A',
      ElectricityCurrentB: 'Elektriciteitsstroom B',
      ElectricityCurrentC: 'Elektriciteitsstroom C',
      ElectricityVoltageA: 'Elektriciteitsspanning A',
      ElectricityVoltageB: 'Elektriciteitsspanning B',
      ElectricityVoltageC: 'Elektriciteitsspanning C',
      ElectricityConsumption: 'Elektriciteitsverbruik',
      loaderWelcomeMessage:
        'Welkom bij het Introductieportaal. Een moment geduld.',
      latitudeAndLongitude: 'Breedte- en lengtegraad',
      siteUpdateSuccessMessage: 'Sitegegevens met succes bijgewerkt',
      siteUpdateErrorMessage: 'Fout bij het bijwerken van sitedetails',
      provisioningFailedMessages: 'Inrichten site mislukt. Probeer het opnieuw',
      onboardAllSites: 'Alle sites introduceren',
      geoCordinatesErrorMsg: 'Controleer de coördinaten',
      tooltipCordinateMessage: 'coördinaten moeten liggen tussen',
      emptyValueMessage: 'Lege waarde niet toegestaan',

      browseFile: 'Door bestanden bladeren',
      fileTypeErrorMsg: 'Dit bestandstype is niet toegestaan',

      orgImgTitle: 'Upload logo van de organisatie',
      orgImgDropTxt: 'Logo slepen en neerzetten',
      orgImgInfoTxt:
        'W {{width}}px X H {{height}}px en alleen *.png bestandsformaat',
      orgImgPreviewTxt: 'Logovoorbeeld bekijken',
      orgImgTooltipTxt:
        'Logo moet een transparante achtergrond hebben en moet contrasteren met de zwarte koptekstachtergrond',
      orgImgSizeOfErrorMsg:
        'Afbeeldingsgrootte moet zijn maximale breedte {{width}}px, maximale hoogte {{height}}px, minimale breedte {{minWidth}}px, minimale hoogte {{minHeight}}px en maximale grootte {{maxSize}}kb',

      siteImgTitle: 'Upload afbeelding site',
      siteImgDropTxt: 'Gebouwafbeelding slepen en neerzetten (.png of .jpg)',
      siteImgPreviewTxt: 'Voorbeeld van sitedetails bekijken',
      siteTooltipTxt:
        'Afbeelding wordt bijgesneden met 46 px aan de rechter- en linkerkant en 30 px aan de boven- en onderkant van de afbeelding op basis van verschillende monitorresoluties',
      siteImgInfoTxt:
        'W {{width}}px X H {{height}}px en *.png & *.jpg bestandsformaat',
      siteImgSizeOfErrorMsg:
        'De afbeelding mag maximaal {{width}} px breed, {{height}} px hoog en {{maxSize}} kb groot zijn',
      orTxt: 'Of',
      addLogo: 'Logo toevoegen',
      addImage: 'Afbeelding toevoegen',
      imageUploadSuccess: 'Afbeelding succesvol geüpload',
      alertnteId: 'Alternatieve gebruikersnaam: ',
      username: 'Gebruikersnaam: ',
      errorFetchingUser: 'Fout bij het ophalen van gebruikersgegevens',
      errorFetchingRoles: 'Fout bij het ophalen van rollen',

      gateway: 'POORT',
      associateAndSyncBtn: 'KOPPELEN EN SYNCHRONISEREN',
      cancelBtn: 'ANNULEREN',
      guidValidationError: 'GUID-validatiefout',
      gatewayId: 'GATEWAY-ID',
      addNewGateway: 'Nieuwe gateway toevoegen',
      successMessage1: 'Koppelen van de site voltooid',
      successMessage2:
        'Koppelen van de site voltooid; modelsynchronisatie wordt gestart',
      errorMessage: 'Koppeling mislukt, modelsynchronisatie wordt niet gestart',
      importUsers: 'Gebruikers importeren',
      importUsersSubHeading:
        'Download het CSV-sjabloon om wat u wilt importeren toe te voegen en te beheren.',
      dropCsvHere: 'Sleep het bestand hierheen of',
      browsrForFiles: 'Naar bestanden bladeren',
      subHeadingBrowser: 'Alleen CSV-bestand van maximaal 5 MB geaccepteerd.',
      subHeadingBrowserTwo: '(slechts één upload tegelijk mogelijk)',
      userUploadSuccess: 'Gegevens met succes verzonden',
      userUploadProcessing:
        'De gegevens zijn met succes geüpload en ze worden nu verwerkt. Dit duurt een paar minuten. U hoort snel meer van ons.',
      fileNameDisplay: 'Bestandsnaam: ',
      fileName: 'Bestandsnaam',
      errorNotification:
        'Bij het uploaden van het sjabloon trad een probleem op. Corrigeer de volgende fouten en upload het sjabloon opnieuw.',
      errorHeading: 'Fout',
      slnumber: 'SERIENR.',
      errorMessageHeading: 'FOUTMELDING',
      endUserAgreement: 'Voorwaarden voor Honeywell Forge',
      privacyStatement: 'Privacyverklaring',
      yourPrivacyChoices: 'Uw privacykeuzes',
      cookieNotice: 'Cookiemelding',
      dataCentre: 'Datacenter',
      isForgeText: 'Gebouwen',
      gatewayIdleMessage:
        'U heeft een paar minuten niets gedaan; vernieuw de pagina om verder te gaan',
      refresh: 'Vernieuwen',
      landingLogin: 'Klik hier',
      loginUserIntegratorRole: 'BA e-commerce gebruikers',
      loginUserCustomerRole: 'Alle andere gebruikers',
      loginWelcomeNote: 'Welkom. Kies hieronder uw rol om te beginnen.',
      termsAndConditions: 'Algemene voorwaarden',
      accept: 'Accepteren',
      legalPatentInformation: 'Wettelijke octrooi-informatie',
      onboardingPortal: 'Introductieportaal',
      customers: 'Klanten',
      templates: 'Sjablonen',
      assetModelling: 'Objectmodellering',
      selectCustomer: 'Selecteer klant',
      integration: 'Integratie',
      integrationSubtitle:
        'Naadloze integratie voor realtime prestatie-inzichten',
      customer: 'Klant',
      accessibleCustomersError:
        'Fout bij het ophalen van toegankelijke klanten',
      workflows: 'Workflows (verouderd)',
      apiCredentials: 'API-inloggegevens',
      integrationsTab: 'Werkstromen',
      noSubscription:
        'Geen actief abonnement gevonden. Abonneer u alstublieft om toegang tot deze functie te krijgen.',
      loading: 'Laden...',
      licenseManagement: 'Licentiebeheer',
      activityLogTitle: 'Activiteitenlogboeken',
      activityLogSubtitle:
        'Volg workflow-gebeurtenissen en statusupdates voor geselecteerde klanten',
      activityLogSidebarTitle: 'Activiteitenlogboeken',
      activityLogSidebarSubtitle:
        'Hier zijn de activiteitengegevens voor al uw klantorganisaties',
      activityLogListTitle: 'Lijst van activiteiten',
      activityLogSearchPlaceholder: 'Zoeken op activiteit, locatie',
      activityLogLastUpdated: 'Laatst bijgewerkt',
      activityLogCreatedOn: 'Gemaakt op',
      activityLogActivity: 'Activiteit',
      activityLogSite: 'Site',
      activityLogStatus: 'Status',
      activityLogCreatedBy: 'Gemaakt door',
      activityLogUpdatedBy: 'Bijgewerkt door',
      activityLogNameUnavailable: 'Naam niet beschikbaar',
      activityLogUserNamesError: 'Kan CreatedBy- en UpdatedBy-namen niet laden',
      activityLogStatusSuccess: 'Gelukt',
      activityLogStatusFailed: 'Mislukt',
      activityLogStatusInProgress: 'In behandeling',
      activityLogStatusQueued: 'In wacht',
      activityLogStatusPending: 'In behandeling',
      activityLogStatusSkipped: 'Overgeslagen',
      activityLogPaginationInfo:
        '{startItem} - {endItem} van {totalItems} items',
      activityLogPageGoTo: 'Ga naar pagina',
      activityLogRowPerPage: 'Rijen per pagina',
      activityLogRetry: 'Opnieuw proberen',
      activityLogRetrying: 'Opnieuw proberen...',
      activityLogRetrySuccess: 'Opnieuw proberen van taak succesvol gestart.',
      activityLogRetryError:
        'Kan taak niet opnieuw proberen. Probeer het opnieuw.',
      activityLogRetryAllSuccess:
        'Alle taken zijn met succes opnieuw uitgevoerd.',
      activityLogRetryAllFailed:
        'Alle herhaalpogingen zijn mislukt. Probeer het alstublieft opnieuw.',
      activityLogRetryPartialFailed:
        'Opnieuw proberen van sommige taken is mislukt. Probeer het opnieuw.',
      activityLogLoading: 'Details worden geladen...',
      activityLogFetchError:
        'Kan activiteitsgegevens niet laden. Probeer het opnieuw.',
      activityLogModalClose: 'Sluiten',
      activityLogModalTasks: 'Taken',
      activityLogModalCreatedOn: 'Gemaakt op',
      activityLogModalLastUpdatedOn: 'Laatst bijgewerkt op',
      activityLogModalSupportNote:
        'Beschrijving van het storingsgeval en de redencode.',
      activityLogModalSupportReach: 'Voor hulp kunt u contact opnemen met',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: 'Filteren op',
      noCustomersAvailable: 'Geen klanten beschikbaar',
      activityLogFilterStatus: 'Status',
      activityLogFilterActivity: 'Activiteit',
      activityLogFilterSite: 'Site',
      activityLogFilterCreatedBy: 'Gemaakt door',
      activityLogFilterApply: 'Toepassen',
      activityLogFilterReset: 'Resetten',
      activityLogFilterNoOptions: 'Geen opties beschikbaar',
      activityLogFilterError:
        'Kan filteropties niet laden. Probeer het opnieuw.',
      search: 'Zoeken',
      more: 'meer',
      noResults: 'Geen resultaten gevonden',
      activityLogCustomizeColumns: 'Kolommen aanpassen',
      activityLogColumnsReorder: 'Opnieuw bestellen',
      activityLogColumnsAddRemove: 'Toevoegen/Verwijderen',
      activityLogColumnsReorderDescription:
        'Herpositioneren om de volgorde van de kolommen in de tabel te wijzigen',
      activityLogColumnsAddRemoveDescription:
        'Selecteer de kolommen die u in de tabel wilt weergeven',
      activityLogDetails: 'Details',
      activityLogFiltersChanged:
        'Geen gegevens gevonden voor de geselecteerde filters. Pas uw filters aan of stel ze opnieuw in om resultaten te zien.',
      activityLogResetFilters: 'Filters opnieuw instellen',
      activityLogSiteState: 'Status',
      activityLogSiteCity: 'Stad',
      workflowTaskCBCustomerCreation: 'CB-klant maken',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        'Update van onboardingstatus in het partnerportaal',
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        'Werk CB-klant-id bij in het partnerportaal',
      workflowTaskEOMCustomerCreation: 'EOM-klant maken',
      workflowTaskOnboardCustomerForAI: 'Klant onboarden voor AI',
      workflowTaskDeleteCustomerInCBPortal: 'Verwijder klant in het CB-portaal',
      workflowTaskUpdateCustomerInCBPortal: 'Werk klant bij in het CB-portaal',
      workflowTaskUpdateCustomerInEOM: 'Klant bijwerken in EOM',
      workflowTaskUpdateCustomerInAssetModelling:
        'Update klant in assetmodellering',
      workflowTaskTrackScanStatusFileAttachment:
        'Volg de scanstatus van de bestandsbijlage',
      workflowTaskCBSiteCreation: 'CB-site maken',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        'Werk CB-site-id bij in het partnerportaal',
      workflowTaskEOMSiteCreation: 'EOM-site maken',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        'Werk EOM Site ID bij in het partnerportaal',
      workflowTaskSyncExistingUsersCBPortal:
        'Synchroniseer bestaande gebruikers met CB Portal',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        'Werk de gebruikerssynchronisatiestatus bij in het partnerportaal',
      workflowTaskCalculateEnergySavingsPotential:
        'Bereken het energiebesparingspotentieel',
      workflowTaskDeleteSiteInCBPortal: 'Verwijder site in het CB-portaal',
      workflowTaskDeleteSiteInEOM: 'Verwijder site in EOM',
      workflowTaskUpdateSiteInCBPortal: 'Werk site bij in het CB-portaal',
      workflowTaskUpdateSiteInEOM: 'Werk de site bij in EOM',
      workflowTaskUpdateSiteInAssetModelling:
        'Site bijwerken in de assetmodellering',
      workflowTaskUpdateSiteInFindAPI: 'Werk de site bij in de Find API',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        'Synchroniseer abonnementsassociatie met CB Portal',
      workflowTaskEnableBrickOntology: 'Brick-ontologie inschakelen',
      workflowTaskOnboardCustomerForgeAPI: 'Klant onboarden op ForgeAPI',
      workflowTaskPublishForgeAPIOnboardingStatus:
        'Publiceer de onboardingstatus van ForgeAPI naar Credential-beheer',
      workflowTaskAddUserInCBPortal: 'Gebruiker toevoegen via het CB-portaal',
      workflowTaskUpdateUserProvisioningStatus:
        'Werk de status van gebruikersinrichting bij',
      workflowTaskDeleteUserInCBPortal: 'Verwijder gebruiker in het CB-portaal',
      workflowTaskUpdateUserDeletionStatus:
        'Werk de status van gebruikersverwijdering bij',
      workflowCustomerCreation: 'Klant maken',
      workflowCustomerDelete: 'Klant verwijderen',
      workflowCustomerUpdate: 'Klant bijwerken',
      workflowFileAttachmentsScan: 'Scanstatus van de bestandsbijlagen',
      workflowSiteCreation: 'Site maken',
      workflowSiteDelete: 'Site verwijderen',
      workflowSiteUpdate: 'Site bijwerken',
      workflowSubscriptionAssociation: 'Abonnementskoppeling',
      workflowAddUser: 'Gebruiker toevoegen',
      workflowDeleteUser: 'Gebruiker verwijderen',
      workflowNamePlate: 'Naamplaat',
      workflowForgeAPIOnboarding: 'Onboarding Forge API',
      workflowAddUserMultiple: 'Workflow om meerdere gebruikers toe te voegen',
      workflowDeleteUserMultiple:
        'Workflow om meerdere gebruikers te verwijderen',
      workflowModelFileUpload: 'Modelbestandsupload',
      workflowGatewayAssociation: 'Gatewaykoppeling',
      workflowIntegrationRegistered: 'Integratie geregistreerd',
      workflowTaskForgeAPIOnboardingStatus: 'Onboardingstatus Forge API',
      workflowTaskAddUser: 'Workflow om gebruiker toe te voegen',
      workflowTaskProcessModelFile: 'Procesmodelbestand',
      workflowTaskNotifyAssetModelling: 'Meld assetmodellering',
      workflowTaskAssociateGateway: 'Gateway koppelen aan site',
      workflowTaskFetchModelToAssetModelling:
        'Model ophalen voor assetmodellering',
      workflowTaskNameProcessNamePlate: 'Verwerk naamplaatbestand',
      workflowTaskUpdateModelInFindAPI: 'Werk het model bij in de Find API',
      workflowTaskProcessIntegrationRegistered:
        'Procesintegratie geregistreerd',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        'Verwerk DF-melding voor integratieregistratie',
      workflowTaskTenantOnboardingAFO:
        'Onboarding van klantorganisatie naar AFO',
      workflowTaskOnboardCustomerCDL: 'Klant onboarden voor CDL',
      workflowTaskPublishAFOOnboardingStatus: 'AFO-onboardingstatus publiceren naar de Rule Builder-service',
      activityLogCorrelationId: 'Correlatie-id',
      activityLogTaskId: 'Taak-id',
      activityLogToastSuccess: 'Gelukt',
      activityLogToastError: 'Fout',
      activityLogIteration: 'Herhaling',
      activityLogFieldFirstName: 'Voornaam',
      activityLogFieldLastName: 'Achternaam',
      activityLogFieldSubscriptionName: 'Abonnementsnaam',
      activityLogFieldName: 'Naam',
      activityLogFieldCurrency: 'Munteenheid',
      activityLogFieldZip: 'Postcode',
      activityLogFieldArea: 'Oppervlakte',
      activityLogFieldCity: 'Stad',
      activityLogFieldState: 'Status',
      activityLogFieldCountry: 'Land',
      activityLogFieldAreaUnit: 'Oppervlakte-eenheid',
      activityLogFieldLanguage: 'Taal',
      activityLogFieldLatitude: 'Breedtegraad',
      activityLogFieldSiteType: 'Type site',
      activityLogFieldTimezone: 'Tijdzone',
      activityLogFieldLongitude: 'Lengtegraad',
      activityLogFieldCountryCode: 'Landcode',
      activityLogFieldSiteId: 'Site-id',
      activityLogFieldFileType: 'Bestandstype',
      activityLogFieldReason: 'Reden',
      activityLogFieldCustomerSupportEmails: 'E-mailadressen voor klantenondersteuning',
      activityLogFieldAddressLine1: 'Adresregel 1',
      activityLogFieldAddressLine2: 'Adresregel 2',
      activityLogFieldContactEmail: 'E-mailadres contact',
      activityLogSiTitle: 'Activiteitenlogboek',
      support: 'Ondersteuning',
      projectManagement: 'Projectbeheer',
    }
  }
};
